import { baseAxios } from "config";
import createApiParams from "utils/createApiParamsTemp";

export const sentAssessmentInvitationBulk = async ({
  assessmentId,
  page,
  limit,
  order,
  orderBy,
  fetchAll,
  filters,
  useOr = false,
  useOrTags = true,
  useElemMatch = false,
  includeDnu,
  orderByOverride,
}) => {
  const { paginationQuery, sortQuery, filterQuery, queryString } = createApiParams({
    page,
    limit,
    order,
    orderBy,
    fetchAll,
    filters,
    orderByOverride,
  });

  const res = await baseAxios.post(
    `/assessments/${assessmentId}/applicants/invite/bulk${queryString}${
      useOr ? "&useOr=true" : ""
    }&tagOper=${useOrTags ? "in" : "all"}${useElemMatch ? "&useElemMatch=true" : ""}${
      includeDnu || filters._id ? "&includeDnu=true" : ""
    }`
  );
  return res.data;
};
